import React from 'react';
import FolderBar from './FolderBar';
import StickyBar from '../StickyBar';
import FolderBarContainer, { OwnProps } from './FolderBar.container';

const FolderBarInContainer = FolderBarContainer(FolderBar);

export const FolderBarInSticky: React.FC<OwnProps> = ({ withBackButton }) => {
  return (
    <StickyBar>
      {() => <FolderBarInContainer withBackButton={withBackButton} />}
    </StickyBar>
  );
};

export default FolderBarInSticky;
